import { AuthProvider } from './AuthProvider';
import { OktaAuthProvider } from './OktaAuthProvider';
import { IAuthProvider } from './IAuthProvider';
import { ConfigService } from '$State/ConfigFreezerService';

let cached: { oktaEnabled: boolean; provider: IAuthProvider } | null = null;

export function getEncompassAuthProvider(): IAuthProvider {
    const oktaEnabled = ConfigService.isEncompassOktaLoginEnabled();

    if (!cached || cached.oktaEnabled !== oktaEnabled) {
        cached?.provider.dispose?.();
        cached = { oktaEnabled, provider: oktaEnabled ? new OktaAuthProvider() : new AuthProvider() };
    }

    return cached.provider;
}
